module.exports = __webpack_public_path__ + "img/signingApprovalFailed2-icon.58724acd.png";